// Algo created to reflect the VDS spacing table: https://volt.wabtec.one/4379730ba/p/201153-spacing
// Supports spacing value of 0 and larger
export const getVdsSpacing = (s: number): number => {
  return s > 1 ? (s - 1) * 4 : s === 1 ? 2 : 0;
};

export const refCallbackPreventPropagation = <T extends HTMLElement>(ref: T | null) => {
  if (!ref) return;

  // Stop the click propagating
  ref.onclick = (e: MouseEvent) => {
    e.stopPropagation();
  };
};
